

if (!customElements.get("product-form")) {
  class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector("form");
      this.form.addEventListener("submit", this.onSubmit.bind(this));
      this.querySelectorAll("[type='submit']").forEach((element) => {
        element.addEventListener("click", this.onClick.bind(this));
      });
      document
        .querySelectorAll(
          `[type='submit'][form='${this.form.getAttribute("id")}']`
        )
        .forEach((element) => {
          element.addEventListener("click", this.onClick.bind(this));
        });
    }

    setSubmitted() {
      this.form.classList.add("submitted");
      document
        .querySelectorAll(`[form='${this.form.getAttribute("id")}']`)
        .forEach((element) => {
          element.classList.add("submitted");
        });
    }

    onClick(event) {
      this.setSubmitted();
      this.submitter = event.currentTarget;
    }

    async onSubmit(event) {
      event.preventDefault();

      //Check form submission method
      let submittedByDispatch = function(){
        if(event.target.classList.contains('shippingProtectionForm')){
          return true
        } else {
          return false
        }
      }

      let submittedByVariantPicker = function(){
        if(event.detail != null){
          return true
        } else {
          return false
        }
      }

      const data = new FormData(this.form);

      if (!Boolean(data.get("id")) || this.submitting) return;

      this.submitting = true;

      event.submitter && (this.submitter = event.submitter);

      if (!submittedByDispatch() && !submittedByVariantPicker()) {
        document.querySelector("cart-notification").setActiveElement(document.activeElement);
        this.submitter.setAttribute("aria-disabled", true);
        this.submitter.innerHTML = ("ADDING...");
      }

      let obj = { quantity: 1 };
      for (let [name, value] of data) {
        const path = name.split('.');
        
        let index = -1,
          length = path.length,
          lastIndex = length - 1,
          nestedObj = obj;

        while (++index < length) {
          let key = path[index],
          objValue = value;

          if (index != lastIndex) {
            objValue = nestedObj[key];
            
            objValue = typeof objValue === 'object'
              ? objValue
              : {};
          }
          nestedObj[key] = objValue;
          nestedObj = nestedObj[key];
        }
      }


      // Gift Card inputs
      const sendGiftCardToRecipent = data.get('properties[__shopify_send_gift_card_to_recipient]') ? data.get('properties[__shopify_send_gift_card_to_recipient]') : false;
      const giftCardRecipentEmail = data.get('properties[Recipient email]') ? data.get('properties[Recipient email]') : false;
      const giftcardRecipentName = data.get("properties[Recipient name]") ? data.get("properties[Recipient name]") : false;
      const giftcardRecipentMessage = data.get("properties[Message]") ? data.get("properties[Message]") : false;
      const giftcardImage = document.querySelector('.gift-card-preview-image')?.src;
      
      // Check if Automation & Threshold properties exist with this product and apply to product properties accordingly.
      const specialInput = data.get("properties[_Special]") ? data.get("properties[_Special]") : false;
      const thresholdInput = data.get("properties[_Threshold]") ? parseInt(data.get("properties[_Threshold]")) : 0;
      const discountInput = data.get("properties[_Discount]") ? parseInt(data.get("properties[_Discount]")) : 0;
      const keyInput = data.get("properties[_Key]") ? data.get("properties[_Key]") : false;

      let specialProps = {};
      if(specialInput)
        specialProps['_Special'] = specialInput

      if(thresholdInput)
        specialProps['_Threshold'] = thresholdInput

      if(discountInput)
        specialProps['_Discount'] = discountInput

      if(keyInput)
        specialProps['_Key'] = keyInput

      if( sendGiftCardToRecipent ){
        specialProps = data.get('properties[Recipient email]') ? { 
          'Message': giftcardRecipentMessage,
          'Recipient email' : giftCardRecipentEmail,
          'Recipent name' : giftcardRecipentName,
          '__image' : giftcardImage,
          '__shopify_send_gift_card_to_recipient' : sendGiftCardToRecipent
        } : {};
      }
      // if( thresholdInput && specialInput ){
      //   specialProps = data.get("properties[Special]") ? { 
      //     _Special : specialInput,
      //     _Threshold : thresholdInput 
      //   } : {};
      // }else if( specialInput ){
      //   specialProps = specialInput ? { 
      //     Special : specialInput
      //   } : {};
      // }

      // specialProps['_Discount'] = discountInput;
      // console.log(specialProps)

      /* If Athlete is present, add the Athlete image. */
      const athleteInput = data.get("properties[Athlete]") ? data.get("properties[Athlete]") : false;
      if(athleteInput)
        specialProps['_Athlete'] = athleteInput;

      const config = window.fetchConfig("javascript");
      config.headers["X-Requested-With"] = "XMLHttpRequest";
      config.body = JSON.stringify({
        items: data.getAll("id").map((id) => ({
          ...obj,
          id,
          properties: specialProps
        })),
        sections: this.getSectionsToRender().map((section) => section.section),
        sections_url: window.location.pathname,
      });

      try {
        const json = await fetch(`${window.routes.cart_add_url}`, config)
        .then(
          (response) => response.json()
        )
        // console.log("json");
        // console.log(json);

        if (json.status) {
          this.handleErrorMessage(response.description);
        } else {
          this.renderLiveSections(json);
        }
      } catch (error) {
        console.error(error);
      }


      if(submittedByVariantPicker()){
        setTimeout(()=>{
          closeStickyVariantSelector();
        }, 1000)
      } else if (!submittedByDispatch()) {
        this.submitter.innerHTML = ("ADDED");
        this.submitter.classList.add("altLoader");
        setTimeout(()=>{
          this.delaySubmit(this.submitter)
        }, 1000)
      }

      // Check for AutoGift
      if (typeof window.runAutoGift === 'function') {
        await window.runAutoGift();
      }

      // Check for AutoDonation
      if (typeof window.runAutoDonation === 'function') {
        window.runAutoDonation();
      }

      this.submitting = false;
    }
  
    delaySubmit(submitter) {
      submitter.removeAttribute("aria-disabled");
      submitter.classList.remove("altLoader");
      submitter.setAttribute("added", "true");
      submitter.innerHTML = ("ADD TO CART")
    }

    onCartPage() {
      return window.location.pathname.startsWith(window.routes.cart_url);
    }
    
    onProductPage() {
      return window.location.pathname.startsWith('/products/');
    }

    getSectionsToRender() {
      if (this.onCartPage()) {
        return document.querySelector("cart-items").getSectionsToRender();
      } else {
        return document
          .querySelector("cart-notification")
          .getSectionsToRender();
      }
    }

    renderLiveSections(json) {
      if (this.onCartPage()) {
        const cartItems = document.querySelector("cart-items");
        cartItems.currentItemCount += 1;
        cartItems.render(json);
      } else {
        if (!this.onProductPage()) {
          setTimeout(() => {document.querySelector("cart-notification").renderContents(json)},900)
        }
        window.location.href = '/cart';
      }
    }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper =
        this.errorMessageWrapper ||
        this.querySelector(".product-form__error-message-wrapper");
      this.errorMessage =
        this.errorMessage ||
        this.errorMessageWrapper.querySelector(".product-form__error-message");

      this.errorMessageWrapper.toggleAttribute("hidden", !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  }

  customElements.define("product-form", ProductForm);
}
